var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup364(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.495 7.552H3.13997C2.7125 7.552 2.36597 7.89853 2.36597 8.326V19.562C2.36597 19.9895 2.7125 20.336 3.13997 20.336H22.495C22.9224 20.336 23.269 19.9895 23.269 19.562V8.326C23.269 7.89853 22.9224 7.552 22.495 7.552Z",
    fill: "#99E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2581 1.88501H25.2109C24.9558 1.88488 24.7033 1.935 24.4675 2.03253C24.2318 2.13007 24.0176 2.27309 23.8372 2.45343C23.6567 2.63377 23.5137 2.84791 23.416 3.08359C23.3184 3.31927 23.2681 3.57188 23.2681 3.827V18.393C23.2681 18.9081 23.0634 19.402 22.6992 19.7662C22.335 20.1304 21.841 20.335 21.3259 20.335H4.30811C3.79306 20.335 3.29901 20.1304 2.93481 19.7662C2.57062 19.402 2.36597 18.9081 2.36597 18.393V3.827C2.36597 3.31195 2.16131 2.81799 1.79712 2.4538C1.43292 2.0896 0.939123 1.88501 0.424072 1.88501V1.88501",
    stroke: "#417EBA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup364);
export default __webpack_public_path__ + "static/media/Group 364.073b286298a9038eb5bcef9113e2677a.svg";
export { ForwardRef as ReactComponent };